module.exports = __webpack_public_path__ + "img/plane_cargo.893824e6.png";